import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { fmtEur } from "@/lib/kpis";

const SERIES = [
    { key: "chiffre_affaires", label: "Chiffre d'affaires", color: "#132447" },
    { key: "ebe", label: "EBE", color: "#B45309" },
    { key: "tresorerie", label: "Trésorerie", color: "#047857" },
];

function CustomTooltip({ active, payload, label }) {
    if (!active || !payload?.length) return null;
    return (
        <div className="rounded-xl border border-slate-200 bg-white shadow-sm px-3 py-2 text-xs shadow-sm">
            <p className="font-medium text-foreground mb-1">Exercice {label}</p>
            {payload.map((p) => (
                <p key={p.dataKey} style={{ color: p.color }}>
                    {p.name} : <span className="tabular-nums">{fmtEur(p.value)}</span>
                </p>
            ))}
        </div>
    );
}

const CHART_MARGIN = { top: 8, right: 16, bottom: 0, left: 8 };
const TICK = { fontSize: 12, fill: "hsl(var(--muted-foreground))" };
const Y_TICK = { fontSize: 11, fill: "hsl(var(--muted-foreground))" };
const CURSOR = { stroke: "hsl(var(--border))" };
const LEGEND_STYLE = { fontSize: 12, paddingTop: 8 };
const DOT = { r: 4, strokeWidth: 2, fill: "#fff" };
const ACTIVE_DOT = { r: 6 };
const PROJ_DOT = { r: 5, strokeWidth: 2, fill: "#FEF3C7", strokeDasharray: "" };

export default function KpiChart({ kpis, commandesGaranties }) {
    if (kpis.length < 2) return null;
    const data = kpis.map((k) => ({ annee: String(k.annee_fiscale), chiffre_affaires: k.chiffre_affaires, ebe: k.ebe, tresorerie: k.tresorerie }));
    const cg = Number(String(commandesGaranties ?? "").replace(/\s/g, "").replace(",", "."));
    const projection = cg > 0;
    if (projection) {
        const last = data[data.length - 1];
        last.ca_projete = last.chiffre_affaires;
        data.push({ annee: `${Number(last.annee) + 1} (garanti)`, ca_projete: cg });
    }
    return (
        <div data-testid="kpi-chart" className="pt-4 border-t border-border">
            <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-3">Évolution par exercice{projection && <span data-testid="kpi-chart-projection" className="ml-2 normal-case tracking-normal text-amber-700">· rebond simulé : commandes garanties {fmtEur(cg)}</span>}</p>
            <ResponsiveContainer width="100%" height={260}>
                <LineChart data={data} margin={CHART_MARGIN}>
                    <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="annee" tick={TICK} axisLine={false} tickLine={false} />
                    <YAxis tickFormatter={(v) => fmtEur(v)} width={80} tick={Y_TICK} axisLine={false} tickLine={false} />
                    <Tooltip content={<CustomTooltip />} cursor={CURSOR} />
                    <Legend iconType="circle" wrapperStyle={LEGEND_STYLE} />
                    {SERIES.map((s) => (
                        <Line key={s.key} type="monotone" dataKey={s.key} name={s.label} stroke={s.color} strokeWidth={2.25} dot={DOT} activeDot={ACTIVE_DOT} connectNulls isAnimationActive={false} />
                    ))}
                    {projection && <Line type="monotone" dataKey="ca_projete" name="CA projeté (commandes garanties)" stroke="#B45309" strokeWidth={2} strokeDasharray="6 4" dot={PROJ_DOT} activeDot={ACTIVE_DOT} connectNulls isAnimationActive={false} />}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
